import React, {useEffect} from 'react'
import {KeyboardDatePicker} from "@material-ui/pickers";
import {TextField, Tooltip, withStyles} from '@material-ui/core';
import Tr from 'translations/Translations';
import clsx from 'clsx';
import getObjectValue from 'libs/getObjectValue';
import DateFormats from "constants/DateFormats";
import moment from "libs/moment";

const style = theme => ({
    root: {
        width: 355,
    }
})

function DatePicker(
    {
        formikProps,
        id,
        label,
        minDate,
        maxDate,
        required = false,
        classes,
        className,
        minDateMessage = Tr("v_data_can_not_be_past"),
        maxDateMessage = Tr("v_data_can_not_be_future"),
        onChange = () => {
        },
        disabled,
        skipCheckTouched,
        tooltip = null,
        hideTooltip = true
    }) {
    const errorValue = getObjectValue(id, formikProps.errors, '')
    const value = getObjectValue(id, formikProps.values, null)
    const touched = getObjectValue(id, formikProps.touched, !!skipCheckTouched)
    const editable = getObjectValue('_editable', formikProps.values, true);

    const isError = !!errorValue && Boolean(touched)
    const helperText = errorValue || ' ';

    useEffect(() => {
        if (typeof value === 'string' || value instanceof String) {
            const momentVal = moment(value);
            if (momentVal.isValid()) {
                formikProps.setFieldValue(id, momentVal);
                formikProps.validateField(id);
            }
        }
        // eslint-disable-next-line
    }, [])

    const textFieldWithTooltip = (props) => (
        <Tooltip placement={"top"} title={tooltip}>
            <TextField {...props} />
        </Tooltip>
    );

    const handleChange = (date) => {
        const value = date ? //
            (date.isValid() ? date.startOf("day") : date)
            :
            null;
        formikProps.setFieldValue(id, value);
        formikProps.setFieldTouched(id, true);
        setTimeout((id) => {
            try {
                formikProps.validateField(id)
            } catch (e) {
            }
        }, 1, id);
        onChange(value ? value.clone() : null)
    }

    const handleError = (err) => {
        if (!Boolean(errorValue)) {
            if (errorValue !== err && err.length > 0) {
                formikProps.setFieldError(id, err)
            }
        }
    }

    return (
        <KeyboardDatePicker
            disabled={disabled || !editable}
            className={clsx(classes.root, className)}
            label={required ? label + '*' : label}
            value={value}
            name={id}
            format={DateFormats.DATE_FORMAT}
            onChange={handleChange}
            onBlur={formikProps.handleBlur}
            error={isError}
            helperText={isError ? helperText : ' '}
            minDate={minDate}
            maxDate={maxDate}
            onError={handleError}
            variant='dialog'
            cancelLabel={Tr('cancel')}
            invalidDateMessage={Tr("invalid_date_format")}
            minDateMessage={minDateMessage}
            maxDateMessage={maxDateMessage}
            inputProps={{
                "data-id": id
            }}
            TextFieldComponent={(!hideTooltip && Boolean(tooltip)) ?
                textFieldWithTooltip
                : undefined}
        />
    )
}

export default withStyles(style)(DatePicker);